import { Button, Input, Modal } from "@mui/joy";
import React, { Dispatch, SetStateAction, useState } from "react";
import { BASE_URL, BLACK, PRIMARY, WHITE } from "../../../../../appConstants";
import CrossIcon from "../../../../../svg/Ads_Dashboard_Developement2/CrossIcon/elements.svg";
import appError from "../../../../../appError";
import { useSelector } from "react-redux";
import axios from "axios";
import toast from "react-hot-toast";
type Condition = {
  metric: string;
  operator: string;
  initial_value: string;
  dependent_value: string;
};
type ConfirmConditionModalProps = {
  setConfirmConditionToggle: Dispatch<SetStateAction<boolean>>;
  setCreateNewCond: Dispatch<SetStateAction<boolean>>;
  local_Cond_name: string;
  setlocal_Cond_name: Dispatch<SetStateAction<string>>;
  local_Cond_id: string;
  localConditionsArr: Condition[];
  newConditionsArr: Condition[];
  fetchConditionsData: () => void;
  ClearAll: () => void;
  setConditionsArr: Dispatch<SetStateAction<Condition[]>>;
  setConditionToggle: Dispatch<SetStateAction<boolean>>;
  isDbDataChanges: boolean;
  setIsDbDataChanges: React.Dispatch<React.SetStateAction<boolean>>;
  page_name: string;
};
const ConfirmConditionModal: React.FC<ConfirmConditionModalProps> = ({
  setConfirmConditionToggle,
  setCreateNewCond,
  local_Cond_name,
  setlocal_Cond_name,
  local_Cond_id,
  localConditionsArr,
  newConditionsArr,
  fetchConditionsData,
  ClearAll,
  setConditionsArr,
  setConditionToggle,
  isDbDataChanges,
  setIsDbDataChanges,
  page_name
}) => {
  const [edit_local_name, setEdit_local_name] =
    useState<string>(local_Cond_name);
  const [temp_list_name_error, setTemp_list_name_error] =
    useState<boolean>(false);

  const { brand_id, platform_id } = useSelector((state: any) => state.appData);
  const [modifyToggle, setModifyToggle] = useState<boolean>(false);

  const updateData = async (new_arr: Condition[]) => {
    const token = localStorage.getItem("token");
    const cleaned_arr = new_arr.map(obj => 
      Object.fromEntries(
        Object.entries(obj).filter(([key]) => !key.endsWith('_error'))
      )
    );
    try {
      setModifyToggle(true);
      const temp_obj = {
        dashboard: page_name,
        condition_name: edit_local_name,
        condition_array: cleaned_arr,
      };
      const res = await axios.put(
        `${BASE_URL}settings/dashboardSettings/conditions/${local_Cond_id}?brand_id=${brand_id}&platform_id=${platform_id}`,
        temp_obj,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(res?.data?.status);
      fetchConditionsData();
      setConditionsArr([...new_arr]);
      setlocal_Cond_name(temp_obj?.condition_name);
      // ClearAll();
      setConfirmConditionToggle(false);
      setIsDbDataChanges(false);
    } catch (error) {
      appError(error);
    } finally {
      setModifyToggle(false);
    }
  };

  const modifyListHandler = () => {
    if (edit_local_name === "") {
      setTemp_list_name_error(true);
      return;
    }
    let tempNewConditions = newConditionsArr.filter(
      (cond: Condition) =>
        cond?.metric !== "" &&
        cond?.operator !== "" &&
        cond?.initial_value !== ""
    );
    let new_arr = [...localConditionsArr, ...tempNewConditions];
    updateData(new_arr);
  };

  const newConditionDisabled = () => {
    return !isDbDataChanges && newConditionsArr?.length === 0;
  }
  return (
    <Modal
      open={true}
      sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
    >
      <div className="relative">
        <div
          style={{
            height: 352,
            width: 600,
            backgroundColor: WHITE.W_100,
            borderRadius: 16,
            padding: 40,
            display: "flex",
            flexDirection: 'column',
            justifyContent: "space-between",
            gap: "40px"
          }}
        >
          <div className="flex flex-col items-start gap-1 self-stretch">
            <div
              style={{
                color: "var(--Text-Primary-Black, #1C1C1E)",
                fontFamily: "Inter",
                fontSize: "20px",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "26px",
              }}
            >
              Confirm Condition Action
            </div>
            <div
              style={{
                color: "var(--Text-Primary-Grey, #97979A)",
                fontFamily: "Inter",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "22px",
              }}
            >
              Do you want to adjust the existing conditions or create an
              entirely new one?
            </div>
          </div>

          <div className="flex flex-col items-start gap-2 self-stretch ">
            <div
              style={{
                color: "var(--Text-Primary-Black, #1C1C1E)",
                fontFamily: "Inter",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "18px",
              }}
            >
              Custom Condition Name
            </div>
            <Input
              placeholder="Condition Name"
              sx={{
                "--Input-focusedThickness": "0px",
                width: "100%",
                height: "44px",
                paddingY: "8px",
                paddingX: "16px",
                fontSize: "12px",
                fontWeight: "500",
                lineHeight: "18px",
                backgroundColor: "#FFF",
                "&.Mui-disabled": {
                  backgroundColor: "#F3F3F7",
                },
                borderRadius: "8px",
                border: "1px solid #EAEAED",
              }}
              name="local_Cond_name"
              value={edit_local_name}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setEdit_local_name(e.target.value)
              }
            />
            {temp_list_name_error && (
              <div className="flex items-center gap-1 self-stretch">
                <div className="flex w-4 h-4 p-[1.33px] justify-center items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <circle
                      cx="7.99967"
                      cy="7.99967"
                      r="6.66667"
                      stroke="#D10C00"
                      stroke-width="1.5"
                    />
                    <path
                      d="M7.99401 10H8"
                      stroke="#D10C00"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8 8L8 5.33333"
                      stroke="#D10C00"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div
                  style={{
                    color: "var(--Text-Event-Red, #D10C00)",
                    fontFamily: "Inter",
                    fontSize: "12px",
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: "18px",
                  }}
                >
                  Condition name already exists
                </div>
              </div>
            )}
          </div>

          <div className="flex gap-4 justify-between">
            <Button
            disabled={newConditionDisabled()}
              // loading={lodingOnSave}
              sx={{
                height: 54,
                width: "50%",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 14,
                fontWeight: 700,
                backgroundColor: "#FFF",
                lineHeight: "18px",
                color: "black",
                borderRadius: 8,
                paddingY: "6px",
                border: "1px solid #EAEAED",
                ":hover": {
                  backgroundColor: "#FFF",
                },
              }}
              onClick={() => {
                setConfirmConditionToggle(false);
                setCreateNewCond(true);
              }}
            >
              Create a new condition
            </Button>
            <Button
              disabled={modifyToggle}
              sx={{
                height: 52,
                width: "50%",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 14,
                fontWeight: 700,
                backgroundColor: "#1565C0",
                lineHeight: "18px",
                color: "#FFF",
                borderRadius: 8,
                paddingY: "6px",
              }}
              onClick={modifyListHandler}
            >
              Modify
            </Button>
          </div>
        </div>
        <div
          className="absolute top-4 right-4 flex p-1 "
          style={{
            zIndex: 100,
            backgroundColor: "#F2F2F5",
            borderRadius: "20px"
          }}
        >
          <img
            src={CrossIcon}
            alt="OverView Icon"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setConfirmConditionToggle(false);
              setConditionToggle(true);
              setIsDbDataChanges(false);
            }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmConditionModal;
